import CustomButton from "components/CustomButton/CustomButton";
import { Column } from "components/styles";
import { SyncState } from "./styles";

const InSyncOfEventUnprocessedButton = ({
    noRecords, toSynchronizeFromTheListingRequest, 
    notExistPendingRecords,
    inSync, doSync, data
}) => {
    return (
        <Column align="center" gap="6px">
            <CustomButton 
                variant="quaternary"
                size="small"
                text="Sincronizar"
                onClick={doSync}
                disabled={!toSynchronizeFromTheListingRequest || notExistPendingRecords || inSync || noRecords || data?.pending === 0}
                />
            {inSync && <SyncState>Sincronizando...</SyncState>}
        </Column>
    );
}

export default InSyncOfEventUnprocessedButton;